import { isFacebookAuthenticated, facebookLoginStatus, loginFacebook } from "src/components/common/Facebook/FacebookClient";
import { Auth, Cache } from "aws-amplify";
import { isGoogleAuthenticated, googleCurrentUser } from "src/components/common/Google/GoogleClient";
import { IsProduction } from "src/services/interfaces/Environment";

export const AuthInterceptor = async config => {
  const jwt = Cache.getItem("jwt");
  if (jwt && jwt.token && new Date().getTime() < jwt.expiration) {
    config.headers.Authorization = jwt.token;
    return config;
  }

  if (IsProduction()) {
    try {
      let fbStatus = await facebookLoginStatus();
      if (isFacebookAuthenticated(fbStatus)) {
        if (fbStatus.status === "authorization_expired") {
          fbStatus = await loginFacebook();
        }
        config.headers.FacebookAccessToken = fbStatus.authResponse.accessToken;
        config.headers.FacebookUserId = fbStatus.authResponse.userID;
        return config;
      }
    } catch (error) {
      console.log("Erro ao carregar auth facebook:");
      console.log(error);
    }

    try {
      const isGoogleAuth = await isGoogleAuthenticated();
      if (isGoogleAuth) {
        const googleUser = await googleCurrentUser();
        const authResponse = await googleUser.reloadAuthResponse();

        config.headers.GoogleJwt = authResponse.id_token;
        return config;
      }
    } catch (error) {
      console.log("Erro ao carregar auth google:");
      console.log(error);
    }
  }

  return Auth.currentSession()
    .then(session => {
      const token = session.getAccessToken().getJwtToken();
      config.headers.Authorization = token;
      Cache.setItem("jwt", {
        token,
        expiration: session.getAccessToken().getExpiration() * 1000
      });
      return config;
    })
    .catch(() => config);
};



// WEBPACK FOOTER //
// ./src/services/middleware/AuthInteceptor.ts